import { render, staticRenderFns } from "./ModuleSearch.vue?vue&type=template&id=312aa69b"
import script from "./ModuleSearch.vue?vue&type=script&lang=js"
export * from "./ModuleSearch.vue?vue&type=script&lang=js"
import style0 from "./ModuleSearch.vue?vue&type=style&index=0&id=312aa69b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports